export default "__VITE_ASSET__C4x4WhCg__"